import { render, staticRenderFns } from "./staff-edit.vue?vue&type=template&id=1fad15ac&scoped=true&"
import script from "./staff-edit.vue?vue&type=script&lang=ts&"
export * from "./staff-edit.vue?vue&type=script&lang=ts&"
import style0 from "./staff-edit.vue?vue&type=style&index=0&id=1fad15ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fad15ac",
  null
  
)

export default component.exports